
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { closeAllModal, showNestedModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Btn from "../../shared/button/Btn"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;
    .modal{
        width: auto;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        .content{
            padding: 40px;
            
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
        }
        .btn-container{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
    }
`

const menuList = [
    {
        id: 1,
        text: "Araç Detayları"
    },
    {
        id: 2,
        text: "Araç Belgeleri"
    },
]

const ProfilAracCloseModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showNestedModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <ModalContainer onClick={()=> dispatch(showNestedModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Araç Detayları"}/>
        <div className="content">
          <p>Kapatırsanız bilgileriniz silinecektir. Kapatmak istediğinize emin misiniz?</p>
        </div>

        <div className="btn-container">
            <Btn bgColor={"#E85446"} color={"#fff"} width={"200px"} handleClick={() => dispatch(showNestedModal(null))} >Devam Et</Btn>
            <Btn bgColor={"transparent"} color={"#E85446"} width={"200px"} handleClick={() => dispatch(closeAllModal())} >Kapat</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default ProfilAracCloseModal